import {actionTypes, resourceTypes} from "../types";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'

import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { serialize } from "../functions";
import {appNotification} from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';
import { transformDate } from "@/utils.js";

const flightOperation = {
    error: '',
    task: {},
    resources: [],
    resourceType: null,
    response: null,
    resName: {'2':'Стойка №', '6':'Выход №'},

    init: function () {
        return m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/operation'
        }).then(function (response) {
            server.setOnline();

            flightOperation.task = response.currentTask;
            flightOperation.resources = response.resources;
            flightOperation.resourceType = response.currentTask?.resourceType;
            flightOperation.response = response;

            storage.config = response.config;

            server.initPing();
            appNotification.init();

            loader.hide();

            return response;
        }, function (response) {
            if (response && response.message) {
                flightOperation.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    
    startRegistrationClick: function (e) {
        const d = new Date();
        const data = {
            factBeginTime: d.toLocaleDateString('en-CA') + ' ' + d.toLocaleTimeString('ru')
        }
        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/task-times',
            data: data
        }).then(function () {
            const a = data.factBeginTime.split(' ');
            flightOperation.response.currentTask.factBeginDateTime = d.toLocaleDateString('en-CA') + ' ' + d.toLocaleTimeString('ru')
            flightOperation.response.currentTask.factBeginTime = d.toLocaleTimeString('ru').substring(0,5);
            server.setOnline();
            loader.hide();
        }, function (response) {
            if (response && response.message) {
                flightOperation.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    endRegistrationClick: function (e) {
        const d = new Date();
        const data = {
            factEndTime: d.toLocaleDateString('en-CA') + ' ' + d.toLocaleTimeString('ru')
        }
        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/task-times',
            data: data
        }).then(function () {
            server.setOnline();
            loader.hide();
            window.location.href = '/';
        }, function (response) {
            if (response && response.message) {
                flightOperation.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    save: function (e) {
        e.preventDefault();
        flightOperation.error = '';

        loader.show();

        const data = serialize(e.target);

        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/operation',
            data: data
        }).then(function () {
            server.setOnline();
            loader.hide();

            if (data.beginHours && data.beginMinutes) {
                flightOperation.task.factBeginTime = data.beginHours + ':' + data.beginMinutes;
            }
            if (data.finishHours && data.finishMinutes) {
                flightOperation.task.factFinishTime = data.finishHours + ':' + data.finishMinutes;
            }

            flightOperation.task.resourceId = data.resourceId;

        }, function (response) {

            data.type = actionTypes.taskOperationSave;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                flightOperation.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    }
};

const timeSelectWithEmptyValueControl = {
    controller: function (args) {

        var self = this;

        this.count = args.type === 'hour' ? 24 : 60;
        this.selectName = args.name;
        this.items = [null];

        Array.apply(null, Array(self.count)).map(function (_, i) {
            self.items.push(i);
        });
    },
    view: function (ctrl) {
        return m("select.form-control", {
            name: ctrl.selectName
        }, [
            ctrl.items.map(function (item) {
                const v = item === null ? '' : (item < 10 ? '0' + item : item);
                return m("option", {
                    value: v
                }, v);
            })
        ]);
    }
};

// голубой блок
export const flightRegistrationBlock = {
    controller: function (args) {
        const ctrl = this;
        ctrl.data = m.prop({...args});

        ctrl.onFactBeginNowclick = function (e) {
            e.preventDefault();
            const d = new Date();
            const newData = {...ctrl.data()};
            newData.resource.factBeginTime = d.toISOString();
            ctrl.data(newData);
        }.bind(ctrl);

        ctrl.onFactEndNowclick = function (e) {
            e.preventDefault();
            const d = new Date();
            const newData = {...ctrl.data()};
            newData.resource.factEndTime = d.toISOString();
            ctrl.data(newData);
        }.bind(ctrl);

        ctrl.saveResourceTimes = function (e) {
            e.preventDefault();
            flightOperation.error = '';

            const values = serialize(e.target);

            loader.show();
            const resource = ctrl.data().resource;
            const data = {
                'flightId': resource.flightId,
                'resourceTypeId': resource.resourceType,
                'resourceFactBegin': (values.resourceFactBeginDate + ' ' + values.resourceFactBeginTime).trim() || null,
                'resourceFactEnd': (values.resourceFactEndDate + ' ' + values.resourceFactEndTime).trim() || null,
            }

            m.request({
                method: 'PUT',
                url: '/api/task/' + m.route.param('taskId') + '/resource-times',
                data: data
            }).then(function () {
                server.setOnline();
                loader.hide();
                window.location.reload();
            }, function (response) {
                if (response && response.message) {
                    flightOperation.error = (m(".alert.alert-danger", response.message));
                } else {
                    server.setOffline();
                }
                loader.hide();
            });
        };
    },

    // голубой блок по рейсу
    view: function (ctrl, args) {
        const data = ctrl.data();
        const resource = data.resource;
        const planBeginTimeT = transformDate(resource.planBeginTime, 'time');
        const planBeginTimeD = transformDate(resource.planBeginTime, 'date', 'en-CA', {month:'numeric'});
        const factBeginTimeT = transformDate(resource.factBeginTime, 'time');
        const factBeginTimeD = transformDate(resource.factBeginTime, 'date', 'en-CA', {month:'numeric'});
        const planEndTimeT = transformDate(resource.planEndTime, 'time');
        const planEndTimeD = transformDate(resource.planEndTime, 'date', 'en-CA', {month:'numeric'});
        const factEndTimeT = transformDate(resource.factEndTime, 'time');
        const factEndTimeD = transformDate(resource.factEndTime, 'date', 'en-CA', {month:'numeric'});

        return m(".bg-info[style='margin:0.75rem; border-radius:0.25rem;overflow:hidden']", [                
            // номер рейса
            m(".flight-number.text-center[style='width:100%;font-weight:bold;background:#cfcde2; padding:0.25rem']", 
                resource.flightNumber),
            // форма
            m(`form[id='form${resource.flightId}'][style='padding:0.75rem']`, {
                onsubmit: ctrl.saveResourceTimes.bind(this)
            }, [
                m("[style='padding:0;margin:0 0 5px 0;border-radius:4px;']",
                m("[style='display:grid;grid-template-columns:1fr 1fr;column-gap:0.5rem;align-items:center']", [
                    // начало 
                    m("[style='font-weight:bold;margins:0;grid-column:span 2']", "Начало"),
                    m("[style='color:#00000066']", 'План'),
                    m(".d-flex.align-items-center.justify-content-between[style='color:#00000066;padding-bottom:0.25rem']", [
                        m("",'Факт'),
                        m('button.btn.btn-primary[type=button]', {onclick:ctrl.onFactBeginNowclick}, 'Сейчас'),
                    ]),
                    m('', [
                        m(`input.form-control[name='resourcePlanBeginDate'][type='date'][readonly]` +
                            `[value='${planBeginTimeD}']`, ''),
                        m(`input.form-control[name='resourcePlanBeginTime'][type='time'][readonly]` +
                            `[value='${planBeginTimeT}']`, ''),
                    ]),
                    m("", [
                        m(`input.form-control[name='resourceFactBeginDate'][type='date']` + 
                            `[value='${factBeginTimeD}']`, ''),
                        m(`input.form-control[name='resourceFactBeginTime'][type='time']` +
                            `[value='${factBeginTimeT}']`, ''),
                    ]),
                    // окончание 
                    m("[style='font-weight:bold;margin:1rem 0 0 0;grid-column:span 2']", "Окончание"),
                    m("[style='color:#00000066']", 'План'),
                    m(".d-flex.align-items-center.justify-content-between[style='color:#00000066;padding-bottom:0.25rem']", [
                        m("",'Факт'),
                        m("button.btn.btn-primary[type=button]", {onclick:ctrl.onFactEndNowclick}, 'Сейчас'),
                    ]),
                    m("", [
                        m(`input.form-control[name='resourcePlanEndDate'][type='date'][readonly]` + 
                            `[value='${planEndTimeD}']`, ''),
                        m(`input.form-control[name='resourcePlanEndTime'][type='time'][readonly]"+
                            "[value='${planEndTimeT}']`, ''),
                    ]),
                    m("", [
                        m(`input.form-control[name='resourceFactEndDate'][type='date']` + 
                            `[value='${factEndTimeD}']`, ''),
                        m(`input.form-control[name='resourceFactEndTime'][type='time']` + 
                            `[value='${factEndTimeT}']`, ''),
                    ]),
                    // строка кнопки
                    m("button.btn.btn-primary[style='grid-column: span 2; margin-top:1rem']", "Сохранить") 
                ])
                ),
            ])
        ]);
    }
};

export const flightOperationPage = {
    controller: function (args) {
        const ctrl = this;
        ctrl.data = m.prop({...args});
        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        const data = flightOperation.init();

        return {
            data: data,
            topMenu: [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ]
        }
    },
    
    view: function (ctrl) {
        const endButtonDisabled = flightOperation.response?.currentTask.factBeginTime ? '' : '[disabled]';
        const resourceName = flightOperation.response?.resources.length
            ? flightOperation.response.resources[0].resourceName
            : '';
        const title = (flightOperation.resName[flightOperation.task.resourceType]||'') + ' ' + resourceName;
        const ctrlData = ctrl.data();
        return [
            m.component(HeaderMenuBlock, {
                time: ctrlData?.time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", ''),
            m.component(flightMenuBlock, {
                board: ctrl.data()?.board,
                menu: ctrl.data().menu,
                tasks: ctrl.data().tasks,
                currentTask: flightOperation.task,
                tab: 'operation',
                showTaskSelect: false,
                showOldBoardInfo: false,                
            }),
            flightOperation.error,
            // серый блок. блок работы
            m("[style='line-height:1.3; margin:0.75rem; padding:0.75rem;background:#e6e6e6;border-radius:0.5rem;']",[
                m(".d-flex.align-items-center.justify-content-between[style='gap:1rem;']",[
                    m("h4[style='font-weight:bold;margin:0;']", flightOperation.task.Work_Name),
                    m("h4[style='']", title),
                ]),
                m("[style='display: grid;grid-template-columns: 1fr 1fr 1fr;gap:0.5rem;']", [
                    m("",''),
                    m("[style='color:#00000066']",'План'),
                    m("[style='color:#00000066']",'Факт'),
                    // начало работы
                    m("label.control-label", "Начало работы"),
                    m("[style='font-size:1.5rem']",flightOperation.task.planBeginTime),
                    m("[style='font-size:1.5rem']",flightOperation.task.factBeginTime??
                        m("button.btn.btn-primary[type=button][style='width:100%']", { onclick: flightOperation.startRegistrationClick }, 'Начать')
                    ),
                    // окончание работы
                    m("label.control-label", 'Окончание работы'),
                    m("[style='font-size:1.5rem']",flightOperation.task.planFinishTime),
                    m("[style='font-size:1.5rem']",flightOperation.task.factFinishTime??
                        m("button.btn.btn-primary[type=button][style='width:100%']" + endButtonDisabled, 
                            { onclick: flightOperation.endRegistrationClick }, 'Завершить')
                    )
                ]),
            ]),

            // голубой блок. массив
            flightOperation.response.resources.map(function (resource) {
                return m.component(flightRegistrationBlock, {
                    resource: resource,
                })
            }),
        ]
    }
};
